var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#megaphone_svg__clip0_625_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41 5.334l-6.98 9.15-.221 1.086c-.376.3-1.018 1.115-.58 1.966.438.85 1.472.526 1.933.258l2.353.612 1.837 4.253 2.126.87 2.45-.612c.386-.215.927-.728 0-1.063-.929-.335-2.333-2.727-2.919-3.88l6.592-.62-6.592-12.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.601,
    cy: 11.095,
    rx: 2.358,
    ry: 7.247,
    transform: "rotate(-29.905 12.601 11.095)",
    fill: "#DAD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.934 4.633c-.207.12-.382.368-.471.81-.09.442-.082 1.03.035 1.731.235 1.402.895 3.175 1.935 4.977 1.04 1.802 2.247 3.26 3.343 4.163.549.454 1.053.753 1.48.897.429.144.732.117.938-.003.207-.12.382-.368.472-.81.09-.442.082-1.03-.036-1.731-.235-1.402-.894-3.175-1.935-4.977-1.04-1.802-2.246-3.26-3.342-4.164-.55-.453-1.054-.753-1.481-.896-.428-.144-.731-.117-.938.003z",
    stroke: "#311E72",
    strokeWidth: 0.802
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.655 17.319c-4.932.497-7.229.596-11.879 1.005M8.694 4.845c-2 2.817-4.122 5.526-7.27 9.81-.135 1.003.253 3.164 2.505 3.671",
    stroke: "#311E72",
    strokeWidth: 0.802
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.156 18.267c.44 1.227 1.572 2.5 3.456 3.708.174.111.206.355.054.496-.846.782-1.984 1.435-3.672.815-1.51-.555-2.963-3.187-2.777-5.226M2.594 17.988a1.337 1.337 0 01-1.829-.483 1.337 1.337 0 01.449-1.837",
    stroke: "#311E72",
    strokeWidth: 0.802
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.056 5.555l-5.214 2.686M23.215 14.784c-1.477-.542-1.992-.571-3.354-.396M14.688.761c-.167.855-.374 1.23-.882 1.941",
    stroke: "#311E72",
    strokeWidth: 0.884,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "megaphone_svg__clip0_625_519"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.102 .142)",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgMegaphone;